import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { HeroIconName, HTMLParser, SvgIcon } from '@gik/ui';

export interface ICalendarAnnouncementTileProps extends React.HTMLAttributes<HTMLDivElement> {
  type: string;
  title: string;
  iconName: HeroIconName;
  selected?: boolean;
  horizontal?: boolean;
}

export function CalendarAnnouncementTile({
  type,
  iconName,
  title: label,
  selected,
  horizontal,
  className,
}: ICalendarAnnouncementTileProps) {
  const bem = bemBlock('calendar-announcement-tile');

  return (
    <div className={bem(null, [{ horizontal }, { vertical: !horizontal }, { selected }, { [type]: type }], className)}>
      <SvgIcon className={bem('icon')} name={iconName} />
      <span className={bem('label')}>
        <HTMLParser rawHtml={label} />
      </span>
    </div>
  );
}
